import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub } from '@fortawesome/free-brands-svg-icons';
import { faArrowUpRightFromSquare, faBriefcase, faCalendar, faCode, faComments, faCompass, faEnvelope, faGraduationCap, faLocationDot, faUser, } from '@fortawesome/free-solid-svg-icons';
const iconMap = {
    faArrowUpRightFromSquare,
    faBriefcase,
    faCalendar,
    faCode,
    faComments,
    faCompass,
    faEnvelope,
    faGithub,
    faGraduationCap,
    faLocationDot,
    faUser,
};
const FaIcon = ({ icon, className }) => {
    const iconDefinition = iconMap[icon];
    if (!iconDefinition) {
        // Handle error if icon is not found
        return _jsx("div", { children: "Icon not found" });
    }
    return _jsx(FontAwesomeIcon, { icon: iconDefinition, className: className });
};
export default FaIcon;
